export default __webpack_public_path__ + "static/media/html.6a342d61.svg";